import { useCallback } from 'react'
import { GridSettings, useSettings } from './useSettings'

interface UpdateArgs {
  gridId: string
  newFilters: { [filterKey: string]: unknown }
}
export function useGridFilters() {
  const [setting, saveSetting] = useSettings('i4uGrids')

  const updateFilterValue = useCallback(
    ({ newFilters, gridId }: UpdateArgs) => {
      const grid = setting[gridId]
      if (!grid || !Array.isArray(grid.columns)) return
      const newSetting = {
        ...setting,
        [gridId]: {
          ...grid,
          columns: grid.columns.map((col) =>
            col.key in newFilters
              ? { ...col, filter: { ...col.filter, value: newFilters[col.key] } }
              : col
          ),
        },
      }
      saveSetting(newSetting as Record<string, GridSettings | undefined>)
    },
    [saveSetting, setting]
  )

  const getFilterValue = useCallback(
    (gridId: string, filterKey: string) => {
      return setting[gridId]?.columns.find((c) => c.key === filterKey)?.filter?.value
    },
    [setting]
  )

  return [updateFilterValue, getFilterValue] as const
}
